<template>
<div
    v-require-identity
    @click="togglePopper"
    :id="referenceId"
    :class="{
        disabled: !isAllowedToEmote,
        'is-active': isPopperActive
    }"
    :title="title"
    class="emote-popper-reference"
    key="popper-ref">
    <span class="icon">
        <Emote :emote="triggerEmoji" :size="14"/>
    </span>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import * as M from '@/store/mutations'
import { createRandomString } from '@shared/utils'

export default {
    name: 'EmotePickerTrigger',
    props: {
        suggestion: Object,
        isAllowedToEmote: Boolean,
    },
    data: () => ({
        referenceId: createRandomString(),
    }),
    computed: {
        ...mapGetters(['popperReferenceSelector', 'selectedEmote']),
        referenceSelector: vm => `#${vm.referenceId}`,
        isPopperActive: vm => vm.referenceSelector === vm.popperReferenceSelector,
        title: vm => (
            !vm.isAllowedToEmote ? 'This post has too many reactions!' : ''
        ),
        triggerEmoji: vm => {
            const emojis = ['😁', '😄', '🤗', '😆', '😋', '🙃']
            const emoji = emojis[Math.floor(Math.random() * emojis.length)]
            return vm.isPopperActive ? emoji : '🙂'
        },
    },
    watch: {
        isPopperActive () {
            if (!this.isPopperActive) {
                this.$store.commit(M.SET_SELECTED_EMOTE, { emote: null })
            }
        },
        selectedEmote (emote) {
            if (!this.isPopperActive) { return }
            // An emote was selected while the popper was active for this
            // picker trigger.
            this.togglePopper()
            this.updateEmoteReaction(emote)
        }
    },
    methods: {
        togglePopper () {
            if (!this.isAllowedToEmote) { return }

            const payload = {
                selector: this.isPopperActive ? null : this.referenceSelector
            }
            this.$store.commit(M.SET_EMOTE_POPPER_REFERENCE_SELECTOR, payload)
        },
        async updateEmoteReaction (emote) {
            const payload = {
                userReacted: true,
                emote,
                suggestionId: this.suggestion.id,
            }
            await this.$store.dispatch('updateEmoteReaction', payload)
            // TODO: Update UI somehow, if this fails. Likely due to hitting
            // the emote quota.
        }
    },
}
</script>

<style lang="scss" scoped>
.emote-popper-reference {
    @include flex-center-children;
    user-select: none;
    cursor: pointer;
    &.disabled {
        cursor: not-allowed;
    }
}

</style>
